module.exports = __webpack_public_path__ + "img/download.16bed02b.svg";